'use client';

import { ChangeEvent, useEffect, useState } from 'react';

import {
  useGetNotificationLatestNews,
  usePatchNotificationLatestNews,
} from '@/entities/notificationSettings';

export enum Habit {
  MORNING = 'morning',
  EVENING = 'evening',
  SNACK = 'snack',
  TOILET = 'restroom',
}

type Item = {
  key: number | string;
  value: string;
  leadingIcon?: string;
};

export const useNewsLetterSetting = () => {
  const { data: fetchedData, isLoading } = useGetNotificationLatestNews();
  const { mutate } = usePatchNotificationLatestNews();
  const [habit, setHabit] = useState(Habit.MORNING);
  const [time, setTime] = useState('0800');

  const autoSetTime = (habit: Habit) => {
    switch (habit) {
      case Habit.MORNING:
        return '0800';
      case Habit.EVENING:
        return '1800';
      case Habit.SNACK:
        return '1200';
      case Habit.TOILET:
        return '1400';
      default:
        return '0800';
    }
  };

  const handleHabit = (e: ChangeEvent<HTMLInputElement>) => {
    setHabit(e.target.value as Habit);
    setTime(autoSetTime(e.target.value as Habit));
  };

  const handleTime = (e: Item) => {
    setTime(String(e.key));
  };

  const reset = () => {
    if (fetchedData?.time && fetchedData?.title) {
      setHabit(fetchedData.title as Habit);
      setTime(String(fetchedData.time));
    }
  };

  useEffect(() => {
    if (fetchedData?.time && fetchedData?.title) {
      setHabit(fetchedData.title as Habit);
      setTime(String(fetchedData.time));
    }
  }, [isLoading, fetchedData]);

  return {
    data: { habit, time },
    onChange: { habit: handleHabit, time: handleTime },
    autoSetTime,
    isLoading,
    mutate,
    reset,
  };
};
